import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DashboardHeader from "../../components/dashboard/DashboardHeader";
import DashboardMain from "../../components/dashboard/DashboardMain";
import DashboardChooseMember from "../../components/dashboard/DashboardChooseMember";
import { setIsMemberChoose } from "../../Services/redux/chooseMember";
import axios from "axios";
import ComponentLoader from "../../components/ui/pageLoader/ComponentLoader";
import { useLocation, useNavigate } from "react-router-dom";

const getfinYearListURL = `${process.env.REACT_APP_API_URL}api/permitted_fy_list`;

// NEW DASHBOARD API
const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const select = useSelector((state) => state.setIsMemberChoose.isMemberChoose);
  const permittedFyList = location?.state?.permittedFyList;

  const [matrixAssetData, setMatrixAssetData] = useState();
  const [equityData, setEquityData] = useState();
  const [topGainersLossersData, setTopGainersLossersData] = useState();

  const [renderKey, setRenderKey] = useState(0);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);

  const prevState = location.state || {};

  const finYearId = sessionStorage.getItem("subFinYearID")
    ? Number(sessionStorage.getItem("subFinYearID"))
    : Number(sessionStorage.getItem("finYearID"));

  const apiOption = {
    headers: {
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
    },
  };

  const getPermittedFyList = async () => {
    try {
      const res = await axios.get(getfinYearListURL, apiOption);
      if (res?.data) {
        const resData = res?.data?.data;
        sessionStorage.setItem("Finyear_List", JSON.stringify(resData));
        navigate(location.pathname, {
          replace: true,
          state: {
            ...prevState,
            // workingFinYear: false,
            permittedFyList: false,
          },
        });
      } else {
      }
    } catch (error) {
      console.error();
    }
  };
  useEffect(() => {
    if (permittedFyList) {
      getPermittedFyList();
    }
  }, [permittedFyList]);

  const buttonConfig = {
    closeHandler: () => dispatch(setIsMemberChoose(false)),
  };
  return (
    <div className="bg-neutral-100 pb-10 pt-24">
      <div className="app-container">
        {isLoading1 || isLoading2 || isLoading3 ? <ComponentLoader /> : null}
        <DashboardHeader />
        <DashboardMain
          equityData={equityData}
          matrixAssetData={matrixAssetData}
          topGainerLossers={topGainersLossersData}
        />
        {select && <DashboardChooseMember buttonConfig={buttonConfig} />}
      </div>
    </div>
  );
};

export default Dashboard;
